<template>
  <section>
    <qx-custom-form
      @sub="sub"
      :noSubBtn="true"
      ref="baseForm"
      :formData="formData"
      :disabled="Boolean(this.reciveNumber)"
    />
  </section>
</template>

<script>
export default {
  props: {
    reciveNumber: {
      default: '',
    },
    file: {
      default: [],
    },
  },
  data () {
    return {
      formData: {
        form: [
          {
            label: '编号',
            value: 'reciveNumber',
            type: 'input',
            default: this.reciveNumber,
            placeholder: '请输入编号',
          },
          {
            label: '单据',
            value: 'file',
            type: 'img',
            accept: 'image/*',
            attr: {
              limit: 1,
            },
            default: this.file,
          },
        ],
        rules: { // 表单验证规则
          reciveNumber: [ // 发票号
            { required: true, message: '请输入发票号', trigger: 'blur' },
          ],
          file: [ // 单据
            { required: true, message: '请上传单据', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async sub () {
      const formData = await this.$refs.baseForm.sub();
      return formData;
    },
  },
  mounted () {
    console.log('输出', this.reciveNumber);
  },
};
</script>

<style>

</style>
